import React, { FC, useCallback, useState } from 'react';
import useContextMenu from './UseContextMenu';
import { getMLRequestAndValidationResultForNotUpdatedShape } from '../Annotation/AnnotationForm/Helpers';
import { MLRequest, AnnotationsForGrid } from '../Annotation/annotation.types';
import { ValidationModalDto } from '../Annotation/AnnotationValidationModal/AnnotationValidationModal.slice';

type Props = {
  canvasEl: fabric.Canvas | null;
  gridData: AnnotationsForGrid[];
  havePermissionToUse: boolean;
  saveFinding: boolean;
  presentAnnotations: AnnotationsForGrid[] | null;
  multiSelectObjects: string[];
  onSetAnnotationIdsForDelete: (ids: string[]) => void;
  onShowDeleteDialog: (show: boolean) => void;
  onLoadLocalization: (mlRequest: MLRequest, validationDto: ValidationModalDto, isUpdate?: boolean) => void;
  onAnnotationEdit: (record: AnnotationsForGrid) => void;
  onFindingSave: (saveFinding: boolean) => void;
  onMultipleSelectedAnnotationsForEdit: (record: AnnotationsForGrid[]) => void;
};

const ContextMenu: FC<Props> = ({
  canvasEl,
  gridData,
  havePermissionToUse,
  saveFinding,
  presentAnnotations,
  multiSelectObjects,
  onSetAnnotationIdsForDelete,
  onShowDeleteDialog,
  onLoadLocalization,
  onAnnotationEdit,
  onFindingSave,
  onMultipleSelectedAnnotationsForEdit
}) => {
  const [findingSelectedForDelete, setFindingSelectedForDelete] = useState<boolean>(false);
  const [findingSelectedForEdit, setFindingSelectedForEdit] = useState<boolean>(false);

  const onFindingDeleted = useCallback(
    (names: string[]) => {
      onSetAnnotationIdsForDelete(names);
      onShowDeleteDialog(true);
      setFindingSelectedForDelete(false);
    },
    [onSetAnnotationIdsForDelete, onShowDeleteDialog]
  );

  const onFindingEdited = useCallback(
    (names: string[]) => {
      if (names.length > 1) {
        let annotations = gridData.filter(x => names.includes(x.id));

        onMultipleSelectedAnnotationsForEdit(annotations);
        setFindingSelectedForEdit(false);

        return;
      }

      const id = names[0];
      let annotation = gridData.find(x => x.id === id);

      if (annotation) {
        const { mlRequest, validationResult } = getMLRequestAndValidationResultForNotUpdatedShape(annotation);

        onLoadLocalization(mlRequest, validationResult);
        onAnnotationEdit(annotation);
        // onSelectAnnotationId('');
      }
      setFindingSelectedForEdit(false);
    },
    [gridData, onAnnotationEdit, onLoadLocalization, onMultipleSelectedAnnotationsForEdit]
  );

  const [contextMenuConfig] = useContextMenu(
    canvasEl,
    findingSelectedForDelete,
    onFindingDeleted,
    findingSelectedForEdit,
    onFindingEdited,
    havePermissionToUse,
    onFindingSave,
    saveFinding,
    presentAnnotations,
    multiSelectObjects
  );

  let canBeDeleted: boolean = false;

  if (contextMenuConfig.show && contextMenuConfig.names.length) {
    const finding = presentAnnotations?.find(x => x.id === contextMenuConfig.names[0]);

    if (finding) {
      canBeDeleted = finding.canBeDeleted;
    }
  }

  if (!contextMenuConfig.show) {
    return null;
  }

  return (
    <div className='menu' style={{ left: contextMenuConfig.left, top: contextMenuConfig.top }}>
      <ul className='menu-options'>
        <li className='menu-option' onClick={() => setFindingSelectedForEdit(true)}>
          Edit
        </li>
        {canBeDeleted && (
          <li className='menu-option' onClick={() => setFindingSelectedForDelete(true)}>
            Delete
          </li>
        )}
      </ul>
    </div>
  );
};

export default ContextMenu;
